import { UserChip } from 'components/user/selectOption/userChip';
import { Fragment, ReactElement } from 'react';
import {
  MentionConstructorModel,
  TextDescriptionModel,
} from 'shared/domain/issue/issueModel';
import { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import { UserOnView } from 'shared/domain/user/types/view';
import { EventDescriptionType } from 'shared/types/eventDescription';

export interface EventDescriptionPartToViewMapper {
  readonly type: EventDescriptionType;
  toMarkupText: () => string;
  toPreview: (index: number) => ReactElement;
  toLabelText: () => string;
}

export class TextDescriptionToViewMapper
  implements EventDescriptionPartToViewMapper
{
  readonly type: EventDescriptionType;
  constructor(private description: TextDescriptionModel) {
    this.type = description.type;
  }

  toMarkupText(): string {
    return this.description.text;
  }

  toPreview(index: number): ReactElement {
    return <Fragment key={index}>{this.description.text}</Fragment>;
  }

  toLabelText(): string {
    return this.description.text;
  }
}

export class MentionToViewMapper
  implements EventDescriptionPartToViewMapper
{
  readonly type: EventDescriptionType;
  readonly user: UserOnView;
  readonly issueId: string;
  readonly siteId: string;
  readonly processId: string;
  readonly userAccesses: UserAccess[];
  constructor(mention: MentionConstructorModel) {
    this.type = mention.type;
    this.user = mention.user;
    this.issueId = mention.issueId;
    this.siteId = mention.siteId;
    this.processId = mention.processId;
    this.userAccesses = mention.userAccesses;
  }

  toMarkupText(): string {
    return `@[${this.user.label ?? this.user.email}](otherUser:${
      this.user._id
    })`;
  }

  toPreview(index: number): ReactElement {

    return (
      <UserChip
        key={index}
        user={this.user}
        userAccesses={this.userAccesses}
        issueId={this.issueId}
        siteId={this.siteId}
        processId={this.processId}
        color='default'
        inlineWithText
      />
    );
  }

  toLabelText(): string {
    return `@${this.user.label}`;
  }
}

export class SelfMentionToViewMapper
  implements EventDescriptionPartToViewMapper
{
  readonly type: EventDescriptionType;
  readonly user: UserOnView;
  readonly userAccesses: UserAccess[];
  readonly issueId: string;
  readonly siteId: string;
  readonly processId: string;
  constructor(mention: MentionConstructorModel) {
    this.type = mention.type;
    this.user = mention.user;
    this.issueId = mention.issueId;
    this.userAccesses = mention.userAccesses;
    this.siteId = mention.siteId;
    this.processId = mention.processId;
  }

  toMarkupText(): string {
    return `@[${this.user.label ?? this.user.email}](currentUser:${
      this.user._id
    })`;
  }

  toPreview(index: number): ReactElement {
    return (
      <UserChip
        key={index}
        user={this.user}
        userAccesses={this.userAccesses}
        issueId={this.issueId}
        siteId={this.siteId}
        processId={this.processId}
        color='primary'
        inlineWithText
      />
    );
  }

  toLabelText(): string {
    return `@${this.user.label}`;
  }
}

export type EventDescriptionPartMapper =
  | TextDescriptionToViewMapper
  | MentionToViewMapper
  | SelfMentionToViewMapper;
